import { Form, Modal } from "antd"
import { type BaseOptionType } from "antd/lib/select"
import React, { useState } from "react"
import { UNRESOLVED_USER_LABEL } from "../../../utils/select/entity-labels.ts"
import { ResolvedSelect } from "../../../components/Select/ResolvedSelect.tsx"

interface AssignProjectManagerModalProps {
  projectManagers: BaseOptionType[]
  defaultSelectedId?: string
  loading: boolean
  onConfirm: (responsibleId: string) => void
  onCancel: () => void
}

export function AssignProjectManagerModal({
  projectManagers,
  loading,
  defaultSelectedId,
  onConfirm,
  onCancel
}: AssignProjectManagerModalProps) {
  const [selectedUserId, setSelectedUserId] = useState<string | null>(
    defaultSelectedId || null
  )

  const handleConfirm = () => {
    if (selectedUserId) {
      onConfirm(selectedUserId)
    }
  }

  return (
    <Modal
      open
      title="Select Project Manager"
      centered
      okText="Confirm"
      cancelText="Cancel"
      cancelButtonProps={{ disabled: loading }}
      okButtonProps={{
        disabled: !selectedUserId,
        loading
      }}
      onOk={handleConfirm}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Form.Item label="Project manager" required>
          <ResolvedSelect
            showSearch
            placeholder="Select project manager"
            value={selectedUserId}
            onChange={setSelectedUserId}
            optionFilterProp="label"
            className="w-full"
            options={projectManagers}
            fallbackLabel={UNRESOLVED_USER_LABEL}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
